import { Component, ChangeDetectorRef, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, Validators, Validator, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { delay } from 'lodash';

// RxJS
import { Observable, Subject } from 'rxjs';
import { map, startWith, debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'autocomplete',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true
    }
  ],
  templateUrl: './autocomplete.component.html'
})
export class AutocompleteComponent implements OnInit, ControlValueAccessor, Validator, OnDestroy {
  constructor(
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.dataForm = this.formBuilder.group({
      selection: [Validators.required, this.requireMatch.bind(this)],
    });
  }

  @Input() options: any[] = [];
  @Input() id: string;
  @Input() parentForm: FormGroup;
  @Input() formControlName: string;
  @Input() isEditable: string;

  private _onDestroy = new Subject();
  isOccupation = false;
  dataForm: FormGroup;
  filteredOptions: Observable<any[]>;
  valid: boolean;
  displayValue: string;
  stopPrefill: boolean = false;
  onChange: any = () => {
  };
  onTouched: any = () => {
  };

  ngOnInit() {
    if(this.dataForm) {
      
      if(!this.isEditable) {
        this.dataForm.disable();
      } 

      this.options = this.options.filter(option => option.ConditionalClause !== '0');

      // filtered options
      this.filteredOptions = this.dataForm.get('selection').valueChanges
        .pipe(
          startWith(''),
          map(value => this.filter(value))
        );


      this.dataForm.get('selection').valueChanges.pipe(
        takeUntil(this._onDestroy),
        debounceTime(300)
      ).subscribe((value: any) => {
        // update value
        this.onChange(value);
        this.isOccupation = this.formControlName === 'Occupation';
      });
    }
  }


  // filter function
  filter(value: any): string[] {
    if (value !== null && value !== '') {

      const filterValue = value.toLowerCase();

      if ('') {
        return [];
      }

      const other = this.options.filter((option: any) => {
        return option.Name.toLowerCase() === 'other';
      });

      const matches = this.options.filter((option: any) => {
        return option.value.toLowerCase().includes(filterValue);
      });

      // @ts-ignore
      if (matches.some(x => x.key === 'Other')) {
        return [...matches.slice(0, 50)];
      } else {
        return [...matches.slice(0, 50), ...other];
      }

    }
    return [];
  }

  // Control Value Accessor interface
  writeValue(value: any) {
    if (value) {
      this.dataForm.get('selection').patchValue(value);
    }
  }

  // Control Value Accessor interface
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // Control Value Accessor interface
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  displayFn(value: any): string {
    if (typeof (value) !== 'string') {
      return '';
    } else {
      this.displayValue = this.getDisplayName(value);
      if (this.displayValue) { return this.displayValue; } else { return value; }
    }
  }

  getDisplayName(optionName) {
    // @ts-ignore
    const option = this.options.filter(bt => bt.Name === optionName);
    if (option.length > 0) {

      const match = option[0];
      // @ts-ignore
      const displayName = match.DisplayName;
      return displayName;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  changeMyControl(input) {
    setTimeout(() => {
      if (!this.stopPrefill) {
        // @ts-ignore
        const match = this.options.filter(x => x.value.toLowerCase() === input.toLowerCase());
        if (match.length > 0) {
          // @ts-ignore
          this.parentForm.controls[this.formControlName].patchValue(match[0].value);
          this.parentForm.controls[this.formControlName].markAsDirty();
          // @ts-ignore
          if (this.isOccupation && match[0].value !== 'Other') {
           // this.parentForm.controls['OccupationOther'].disable();
          }
        } else {
          if (this.isOccupation) {
            window['setTimeout'](() => {
              this.parentForm.controls['Occupation'].patchValue('Other');
              this.parentForm.controls['OccupationOther'].enable();
              this.parentForm.controls['OccupationOther'].patchValue(input);
            }, 150);
           
          } else {
            this.parentForm.controls[this.formControlName].reset();
            //this.dataForm.get('selection').clearValidators();
            this.parentForm.controls[this.formControlName].patchValue(input);
          }
        }
      }
    }, 100);
  }

  stopPrefillonSelect() {
    this.stopPrefill = true;
    setTimeout(() => {
      this.stopPrefill = false;
    }, 150);
  }

  // selectedOption(evt: any) {
  //   if (evt.source.selected) {
  //     setTimeout(() => {
  //       // @ts-ignore
  //       const option = this.options.filter(bt => bt.Name === evt.source.value);
  //     }, 200);
  //   }
  // }

  validate(): ValidationErrors | null {
    if (this.isOccupation) {
      return this.dataForm.valid ? null : { isValidOccupation: false };
    } else {
      return null;
    }
  }

  private requireMatch(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match;
    this.options.forEach(function (value) {
      // @ts-ignore
      if (value.Name === selection) {
        match = value;
        return null;
      }
    });
    if (!match) {
      return { isValidOccupation: false };
    }
  }
}
